import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import validate from './validate';
import { renderField, renderTextarea } from '../../../utils/renderFields';
import { submitFeedback } from '../../../actions/globalConfig';
import { getFlashVersion } from '../../../utils';

const propTypes = {
  removeModal: PropTypes.func,
}

const defaultProps = {
  removeModal: () => {},
  initialValues: {
    referer: '',
    browserInfo: '',
  }
}

class FeedbackForm extends React.Component {

  constructor(props){
    super(props);
    this.submit = this.submit.bind(this);
  }

  submit(values) {
    return this.props.dispatch(submitFeedback(values));
  }

  render(){
    const { error, handleSubmit, submitting, submitSucceeded } = this.props;

    return(
      <div className="p-20" id="feedback-form-content">
        <p><strong>Before contacting us, please check the featured comment at the top of the live cam chat board.
          Most questions about the live cams can be answered by reading featured information from moderators.</strong>
          &nbsp;Explore.org doesn’t have the staff to field all questions and concerns immediately.  Before submitting
          your question, please review the links below to see if they help. </p>

        <p><a href="https://explore.org/help" title="Frequently asked questions">Frequently Asked Questions.</a></p>

        <p><a href="https://explore.org/community-guidelines" title="Community Guidelines">Community Guidelines</a></p>

        <p><a href="https://files.explore.org/files/Explore_Website_Handbook.pdf" title="Explore Website Handbook" target="_blank" rel="nofollow noreferrer">Explore Website Handbook</a></p>

        <p><a href="https://explore.org/press" title="Press and Media Inquiries">Press and Media Inquiries</a></p>

        <p><a href="https://help.disqus.com/en/collections/191718-commenting" title="Disqus Commenting Help Manual" target="_blank" rel="nofollow noreferrer">Disqus Commenting Help Manual</a></p>

        <a href="mailto:911@explore.org">911@explore.org</a>   -  Never call authorities!  Instead, trust us to handle it.  We understand your concerns at times but I assure you these are world class non-profits and would never endanger an animal.
        <p>&nbsp;</p>
        <p>If none of the resources above answer your question, please fill out the form below.</p>

        <form onSubmit={handleSubmit(this.submit)}>
          <span className={error ? 'has-danger' : ''}>
            <span className="u-fontSize-11 form-control-feedback">{error}</span>
          </span>

          {submitSucceeded && !submitting &&
            <div className="text-center">
              <p>Your feedback has been submitted!</p>
              <div><button className="btn btn-cancel" onClick={(e)=>{this.props.removeModal(e)}}>Close</button></div>
            </div>
          }

          {submitting && !submitSucceeded &&
            <div className="text-center">
              <p>Submitting feedback...</p>
            </div>
          }

          {!submitting && !submitSucceeded &&
            <div>
              <Field component={renderField} name="name" type="text" label="name" className="form-control" />
              <Field component={renderField} name="email" type="email" label="email" className="form-control" />
              <Field component={renderField} name="subject" type="text" label="subject" className="form-control" />
              <Field component={renderTextarea} name="body" type="textarea" label="share your thoughts." className="form-control" />

              <Field component="input" type="hidden" name="referer" />
              <Field component="input" type="hidden" name="browser_info" />

              <div className="d-flex justify-content-between">
                <div><button className="btn btn-cancel" onClick={(e)=>{this.props.removeModal(e)}}>Cancel</button></div>
                <div><input type="submit" value="Submit" id="submit" className="btn btn-primary" disabled={submitting} /></div>
              </div>
            </div>
          }

        </form>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    removeModal: ownProps.removeModal,
    initialValues: {
      referer: window.location.href,
      browser_info: 'Flash version: ' + getFlashVersion().split(',').shift()
    }
  }
}

FeedbackForm = reduxForm({
  form:'feedback',
  validate, fields:[
    'name',
    'email',
    'subject',
    'body',
  ]
})(FeedbackForm);

FeedbackForm.propTypes = propTypes;
FeedbackForm.defaultProps = defaultProps;

export default connect(mapStateToProps)(FeedbackForm);
